<template>
      <div class="disclaimer email-verification">
        <div class="disclaimer-body flex row align-center gap-10 mb-5 w-full justify-between">
          <div class="flex align-start gap-5px mb-5 column ">
              <div class="req-warning"> <img src="@/assets/warning_.svg">Verify your email to generate reports: </div> 
              <div class="disclaimer-text">The following email
                <b>
                <text v-if="userInformation && !userInformation.email_verified">
                  {{ userInformation.email }}</text>
                </b>
                is required to be verified to be able to generate reports</div>
          </div>
          <button
              class="verify-button"
              @click="sendVerificationEmail()"
              v-if="(userInformation && !userInformation.email_verified) || (user && !user.email_verified)"
            >Verify Email
            <img src="@/assets/arrow-opener.svg" style="margin-left: 10px;">
          </button>
        </div>
      </div>
</template>

<script setup>

    import { computed } from 'vue'
    import API from '../api/index'
    import store from '../store';
    const userInformation = computed(() => store.state.userInformation)
    const user = computed(() => store.state.user)

    async function sendVerificationEmail() {
      const resp = await API.sendVerificationEmail('user-info');
      console.log(resp)
      
    }
</script>

<style scoped lang="scss">


.verify-button {
  width: 120px;
  min-width: 120px;
  margin-left: 20px;
  height: 35px;
  margin-top: 10px;
}

.disclaimer {
  box-shadow: 0px 0px 1.5px 0px #949494;
  padding: 20px;
  width: 100%;
  border-radius: 10px;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  background-color: white;
  // background-color: #FEF4F5;
}
.req-warning {
  color: black;

  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  img {
      margin-right: 20px;
  }
}
.warning-point {
  padding-left: 40px;
  font-size: 14px;
  font-weight: 500;
  margin-left: 25px;
  position: relative;
  &::before {
      content: '';
      position: absolute;
      left: 25px;
      top: 8px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #BB3530;
  }
}
.disclaimer-text {
  padding-top: 3px;
  font-size: 14px;
  font-weight: 500;
  padding-left: 47px;
  text-align: left;
}
.disclaimer-body {
    background-color: #FAF7F6;
    padding: 20px;
    border-radius: 10px;
    box-sizing: border-box;
}
</style>